module.exports = __webpack_public_path__ + "ba2909acd18e8d0801eab4ecae101c46.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/YT.svg
// module id = ypMw
// module chunks = 0